/** Unwraps the flat `{ success, ...fields }` envelope used by betterfood-backend. */
export function unwrapResponse<T>(res: { data: Record<string, unknown> }): T {
  const { data } = res;
  if (data.success === false) {
    throw new Error((data.error as string) || 'Request failed');
  }
  const { success: _s, ...rest } = data;
  return rest as T;
}

export function getApiErrorMessage(err: unknown, fallback = 'Something went wrong'): string {
  const axiosErr = err as {
    response?: { data?: { error?: string; message?: string } };
    message?: string;
  };
  return (
    axiosErr?.response?.data?.error ||
    axiosErr?.response?.data?.message ||
    (err instanceof Error ? err.message : undefined) ||
    fallback
  );
}
